'use strict';

function AddQuotesToGroupInvoiceController(
    $scope,
    $mdDialog,
    $filter,
    quoteIds,
    groupInvoicesP
) {
    'ngInject';

    $scope.groupInvoicesP = groupInvoicesP;
    $scope.selectedGroupInvoice = {
        id: 0
    };

    groupInvoicesP.$promise.then((groupInvoices) => {
        $scope.groupInvoices = [{
            id: 0 // will be 'new' option
        }, ...groupInvoices];
    });

    $scope.getGroupInvoices = function() {
        return groupInvoicesP;
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };

    $scope.save = function() {
        $mdDialog.hide({
            groupInvoice: this.selectedGroupInvoice
        });
    };
}

export default AddQuotesToGroupInvoiceController;
